import { findEnabledSetting } from "@/features/notification-settings/utils/findEnabledSetting";
import type { GetNotificationSettings } from "@/server-types";

/** The server sends a Billing document notification only with the feature and an enabled setting. */
export function isBillingDocumentNotificationOn(args: {
  hasSubscriptionNotifications: boolean;
  notificationSettings: GetNotificationSettings["response"] | undefined;
}): boolean {
  return (
    args.hasSubscriptionNotifications &&
    findEnabledSetting(args.notificationSettings?.settings, {
      event: "subscriptionBillingDocument",
    }) !== undefined
  );
}
